<template>
  <div style="width:90%; margin-left:5%;">
    <div class="story" v-if="!showSingleMore">
      <div class="img-box">
        <img src="../../src/assets/basketballActivities/s.jpg" alt="" />
      </div>
      <div v-loading="isLoading">
        <div class="schedule-list">
          <div
            v-for="(item, index) in schedulesfilter"
            :key="index"
            class="schedule-item"
            :class="[
              {
                'active-schedule':
                  bothactiveSchedule.id === item.id && headType === '1'
              },
              {
                'active-schedule-f':
                  bothactiveSchedule.id === item.id && headType === '2'
              },
              { 'schedule-item-f': headType === '2' }
            ]"
            @click="selectSchedules(item)"
          >
            {{ item.id == 0 ? $t("story." + item.name) : item.name }}
          </div>
          <div class="select" :class="{ 'option-f': headType === '2' }">
            <el-select
              clearable
              @change="getStories()"
              :popper-append-to-body="false"
              :no-data-text="$t('home.nodata')"
              v-model="team_id"
              :placeholder="$t('schedule.select')"
            >
              <el-option
                v-for="item in teamsInfo"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <p class="team-name">
                  {{ item.name }}
                </p>
              </el-option>
            </el-select>
          </div>
        </div>
        <ChartPercentage
          v-if="selectedYears != 0 && !isDataEmpty"
          :chartData="chartData"
        />
        <div v-if="stories_data" class="story-img">
          <div
            class="single-story"
            v-for="(item, index) in stories_data"
            :key="index"
          >
            <div class="picture">
              <el-image
                class="image-cover"
                :src="item.photos[0].temp_path_url"
                fit="cover"
                style="width:100%;height:100%;"
                @click="readMore(item)"
              >
                <div slot="placeholder" class="image-slot slot">
                  <span class="dot" style="color:#4d8bc4;font-size:20px;"
                    ><i class="el-icon-loading"
                  /></span>
                </div>
              </el-image>
              <span
                class="title"
                :style="{ background: headType === '2' ? '#B9A2C9' : '' }"
                >{{ watchImg != 0 ? item.title_zh_hk : item.title_en }}</span
              >
            </div>
            <div
              class="content"
              v-html="watchImg != 0 ? item.details_zh_hk : item.details_en"
            ></div>
            <div
              :class="['read-more', { 'read-color': headType === '2' }]"
              @click="readMore(item)"
              v-text="watchImg != 0 ? '閱讀更多' : 'Read more'"
            >
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-stories" v-else>
      <morestories
        :name="'more'"
        @show="isShowSingleMore"
        :info="stories_info"
        :showIndex="showIndex"
      ></morestories>
    </div>
    <div
      class="none"
      v-if="lenght == 0"
      :style="{ color: headType === '2' ? '#c09fcd' : '' }"
      v-text="watchImg != 0 ? '即將推出' : 'Coming Soon'"
    >
      <!-- {{ $t('home.nodata') }} -->
    </div>
  </div>
</template>
<script>
import { BasketballApi } from "../api/basketball";
// import MoreCom from "../components/MoreCom.vue"
import morestories from "./MoreStories";
import ChartPercentage from "./components/chartpercentage/ChartPercentage.vue";
import { mapState } from "vuex";

export default {
  components: {
    morestories,
    ChartPercentage
    // MoreCom
  },
  data() {
    return {
      optionShow: false,
      optList: ["test1", "test2", "test3", "test4"],
      showSingleMore: false,
      showIndex: null,
      watchImg: window.localStorage.getItem("watchImg") || 0,
      schedules: [
        { name: "all", id: 0 },
        { name: "2024-25", id: 2024 },
        { name: "2023-24", id: 2023 },
        { name: "2022-23", id: 2022 },
        { name: "2021-22", id: 2021 },
        { name: "2020-21", id: 2020 },
        { name: "2019-20", id: 2019 }
      ],
      selectedYears: 0,
      bothactiveSchedules: { name: "all", id: 0 },
      bothactiveSchedules_girl: { name: "all", id: 0 },
      page: 1,
      count: 10,
      stories_data: null,
      stories_info: null,
      isLoading: false,
      lenght: 1,
      type: "m",
      teamsInfo: [],
      team_id: "",
      chartData: {}
    };
  },
  watch: {
    headType() {
      this.getStories();
    }
  },
  computed: {
    ...mapState(["headType"]),
    schedulesfilter() {
      return this.headType == "1" ? this.schedules : this.schedules.slice(0, 3);
    },
    bothactiveSchedule() {
      return this.headType == "1"
        ? this.bothactiveSchedules
        : this.bothactiveSchedules_girl;
    },
    isDataEmpty() {
      return Object.keys(this.chartData).length === 0;
    }
  },
  methods: {
    // get team list
    getTeams() {
      this.teamloading = true;
      BasketballApi.getTeams({
        year:
          this.selectedYears === 0
            ? 2023
            : this.selectedYears,
        type: this.headType === "1" ? "m" : "w"
      }).then((result) => {
        this.teamsInfo = result;
        this.teamloading = false;
      });
    },
    getValue() {
      this.optionShow = !this.optionShow;
    },
    getStories() {
      this.isLoading = true;
      this.lenght = 1;
      this.stories_data = null;
      this.total = true;
      this.type = this.headType == "2" ? "w" : "m";
      this.yearId =
        this.headType == "1"
          ? this.bothactiveSchedules.id
          : this.bothactiveSchedules_girl.id;
      const datas = {
        page: this.page,
        count: this.count,
        year: this.yearId,
        total: this.total,
        type: this.type,
        team_id: this.team_id
      };
      BasketballApi.getStoryList(datas).then((res) => {
        this.stories_data = res.stories;
        this.lenght = res.total_count;
        this.isLoading = false;
      });
    },
    // select Schedule
    selectSchedules(item) {
      if (this.headType == "1") {
        this.bothactiveSchedules = item;
      } else {
        this.bothactiveSchedules_girl = item;
      }
      this.selectedYears = item.id;
      this.getStories();
      this.getStatisticsChart();
    },
    isShowSingleMore(obj) {
      this.showSingleMore = obj;
    },
    showMore() {
      this.queries.page++;
    },
    readMore(item) {
      this.showSingleMore = true;
      this.stories_info = item;
      location.hash = item.id;
    },
    getStatisticsChart() {
      this.chartData = {};
      if (this.selectedYears != 0) {
        let type = this.headType === "1" ? "m" : "w";
        let year = this.selectedYears;
        BasketballApi.getStatistics(type, year).then((result) => {
          if (result.data.length > 0) {
            this.chartData = { ...result.data[0] };
            console.log(this.chartData);
          }
          this.teamloading = false;
        });
      }
    }
  },
  created() {
    if (this.$route.query.team_id) {
      this.team_id = Number(this.$route.query.team_id);
    }
    this.getStories();
    this.getTeams();
    this.getStatisticsChart();
  }
};
</script>
<style lang="scss">
.el-select {
  // margin: 40px 50px 0 0;
  width: 203px;
  border: none;
  // float: right;
  .el-input {
    .el-select__caret {
      color: #318bc8;
    }
    .el-input__inner {
      height: 37px;
      border: 1px solid #318bc8;
      border-radius: 15px;
      color: #318bc8 !important;
    }
  }
  .el-select-dropdown__item.selected {
    color: #318bc8;
  }
  .team-name {
    text-align: left;
  }
}
</style>
<style lang="scss" scoped>
.story {
  .img-box {
    margin-top: 1%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .schedule-list {
    display: flex;
    align-items: center;
    .schedule-item {
      border: 2px solid #5e98ca;
      border-radius: 5px;
      padding: 5px 15px;
      margin: 15px 10px 15px 0;
      color: #4d88c0;
      cursor: pointer;
    }
    @media screen and (max-width: 768px) {
      justify-content: space-around;
      .schedule-item {
        margin: 15px 0;
      }
    }
    .active-schedule {
      background: #5e98ca;
      color: #fff;
    }
    .schedule-item-f {
      border: 2px solid #b9a2c9;
      color: #836099;
    }
    .active-schedule-f {
      background: #b9a2c9;
      color: #fff;
    }
  }
  .story-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    // padding: 4% 4%;
    // padding: 4% 7%;
    .single-story {
      width: 340px;
      border-radius: 40px;
      overflow: hidden;
      margin: 0 26px 24px 0;
      border: 1px solid #e7e7e7;
      padding-bottom: 10px;
      transition: all 0.6s;
      @media screen and (max-width: 768px) {
        width: 95%;
        margin: 0;
        margin-left: 2.5%;
        margin-bottom: 20px;
      }
      .picture {
        position: relative;
        height: 300px;
        overflow: hidden;
        .slot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .image-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: top !important;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: top !important;
        }
        .title {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 3% 0 3% 4%;
          background: #4d8bc4;
          color: #fff;
        }
        ::v-deep(.el-image__inner) {
          object-fit: cover !important;
          object-position: top !important;
        }
      }
      .content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        // font-size: 16px;
        color: #848388;
        padding: 4% 4% 0;
      }
      .read-more {
        width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 20px auto 10px;
        // padding: 3px 0;
        border: 1px solid #4d8bc4;
        border-radius: 24px;
        color: #4d8bc4;
        cursor: pointer;
        transition: all 0.6s;
      }
      .read-more:hover {
        background: #4d8bc4;
        color: #fff;
      }
      .read-color {
        border: 1px solid #b9a2c9;
        color: #b9a2c9;
      }
      .read-color:hover {
        background: #b9a2c9;
        color: #fff;
      }
    }
    // .single-story:nth-child(3n) {
    //   margin: 0 0 24px 0;
    // }
    .single-story:hover {
      transform: scale(1.1);
    }
  }
  .show-more {
    max-width: 150px;
    min-width: 50px;
    width: 80%;
    margin: 0 auto;
    padding: 5px 0;
    border: 1px solid #4d8bc4;
    border-radius: 20px;
    color: #4d8bc4;
    text-align: center;
    transition: all 0.6s;
  }
  .show-more:hover {
    background: #4d8bc4;
    color: #fff;
  }
}
.none {
  width: 100%;
  text-align: center;
  font-size: 30px;
  color: #4d8bc4;
  margin-top: 10px;
}
.wait {
  // width: 100%;
  height: 500px;
  font-size: 30px;
  color: #4d8bc4;
  margin: 4% auto;
  text-align: center;
}
// .select {
//   height: 60px;
//   width: 250px;
//   border: 2px solid rgb(170, 218, 240);
//   border-radius: 15px;
//   line-height: 60px;
//   // margin: auto;
//   position: relative;
//   color: rgb(90, 189, 235);
//   font-size: 12px;
//   font-weight: 600;
//   text-align: left;
//   // padding-left: 20px;
//   margin: 50px auto;
//   cursor: pointer;
//   span {
//     margin-left: 20px;
//   }
//   .tringle {
//     width: 0;
//     height: 0;
//     border-left: 6px solid transparent;
//     border-right: 6px solid transparent;
//     border-top: 8px solid rgb(94, 152, 202);
//     position: absolute;
//     top: 25px;
//     right: 20px;
//   }
//   .option {
//     width: 100%;
//     border: 2px solid rgb(170, 218, 240);
//     list-style: none;
//     // margin-top: -3px;
//     color: rgb(90, 189, 235);
//     padding-left: 20px;
//     background: #fff;
//     border-radius: 5px;
//   }
// }
</style>
